var map = {
	"./WhatsApp Image 2024-03-21 at 14.51.30 (1).jpeg": 4312,
	"./WhatsApp Image 2024-03-21 at 14.51.30 (10).jpeg": 8456,
	"./WhatsApp Image 2024-03-21 at 14.51.30 (11).jpeg": 1732,
	"./WhatsApp Image 2024-03-21 at 14.51.30 (12).jpeg": 1476,
	"./WhatsApp Image 2024-03-21 at 14.51.30 (13).jpeg": 4804,
	"./WhatsApp Image 2024-03-21 at 14.51.30 (2).jpeg": 4780,
	"./WhatsApp Image 2024-03-21 at 14.51.30 (3).jpeg": 9680,
	"./WhatsApp Image 2024-03-21 at 14.51.30 (4).jpeg": 1152,
	"./WhatsApp Image 2024-03-21 at 14.51.30 (5).jpeg": 836,
	"./WhatsApp Image 2024-03-21 at 14.51.30 (6).jpeg": 2364,
	"./WhatsApp Image 2024-03-21 at 14.51.30 (7).jpeg": 812,
	"./WhatsApp Image 2024-03-21 at 14.51.30 (8).jpeg": 3912,
	"./WhatsApp Image 2024-03-21 at 14.51.30 (9).jpeg": 3456,
	"./WhatsApp Image 2024-03-21 at 14.51.30.jpeg": 1280
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9848;